import React, { FC } from 'react';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppAuthenticationState } from '@dxb-web-ui-framework/iam/contexts/AppAuthentication/hooks';
import { AppLoader } from '../../../packages/content-composer/src/components/Generic/AppLoader';
import { AppError } from '../../../packages/content-composer/src/components/Generic/AppError';
import { UserInfoProvider } from '../../../packages/userProfile/src/contexts/UserInfo';
import { ProvidersApp } from '../ProvidersApp';

const UserRouter: FC<GenericObject & { appErrorCallbackOverride: () => void }> = ({
  brandConfig,
  appErrorCallbackOverride,
}) => {
  const { entitlements } = useAppAuthenticationState();
  const { t } = useTranslation();

  if (!entitlements) {
    return <AppLoader />;
  }

  return (
    <UserInfoProvider
      entitlements={entitlements}
      loaderComponent={<AppLoader />}
      errorComponent={
        <AppError
          fullHeight
          message={t('ProvidersApp.UserInfoProvider.AppError.Message')}
          btnLabel={t('ProvidersApp.AppError.btnLabel')}
          onClickBtn={appErrorCallbackOverride}
        />
      }>
      <Routes>
        <Route path='/:customerId/*' element={<ProvidersApp brandConfig={brandConfig} />} />
      </Routes>
    </UserInfoProvider>
  );
};

export { UserRouter };
